module.exports = __webpack_public_path__ + "DINNextLTPro-Medium.ttf?ba26a7ac196fedae18532704c04ef8cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Medium.ttf
// module id = 1381
// module chunks = 0